/* =============================================================================
easyStumpOutLocations.ts

Version: v01
Date: 2026-04-13

Description:
- Location-specific config for EasyStumpOut landing pages.
- Add more locations by adding more entries to EASY_STUMP_OUT_LOCATIONS.
============================================================================= */

export const Locations = {
  coloradoFrontRange: "coloradoFrontRange",
  cheyenne: "cheyenne",
  denver: "denver"
} as const;


export type ILocationConfig = {
  key: string;
  webSiteVersion: string;
  websiteName: string;

  logoPart1:string;
  logoPart2:string;
  logoPart3:string;

  websiteUrl: string;
  businessName: string;
  phoneNumber: string;
  phoneNumberFormatted: string;
  phoneHref: string;
  email: string;
  hours: string;
  serviceAreas: string[];
  brandKicker: string;
  metaTitle: string;
  metaDescription: string;
  ogTitle: string;
  ogDescription: string;
  schemaType: string;
  schemaDescription: string;
  areaServed: string;
  priceRange: string;
  image: string;
  address: {
    streetAddress: string;
    addressLocality: string;
    addressRegion: string;
    postalCode: string;
    addressCountry: string;
  };
  leadDomainName: string;
  leadItemCategory: string;
  leadItemType: string;
  seasonalNote: string;
};


export type PageConfig_PROPS = {
  locationConfig: ILocationConfig;
};


export const EASY_STUMP_OUT_LOCATION_DATA: Record<string, ILocationConfig> = {
  coloradoFrontRange: {
    key: "coloradoFrontRange",
    webSiteVersion: "v02c",
    websiteName: "EasyStumpOut.com",
    logoPart1:"Easy",
    logoPart2:"Stump",
    logoPart3:"Out.com",

    websiteUrl: "https://easystumpout.com",
    businessName: "EasyStumpOut",
    phoneNumber: "7205383528",
    phoneNumberFormatted: "(720) 538-3528",
    phoneHref: "tel:+17205383528",
    email: "quotes@EasyStumpOut.com",
    hours: "Mon–Sat, 8am–6pm",
    serviceAreas: [
      "Fort Collins",
      "Johnstown",
      "Berthoud",
      "Loveland",
      "Longmont",
      "Boulder",
      "Superior",
      "Louisville",
      "Lafayette",
      "Erie",
      "Northglenn",
      "Broomfield",
      "Thornton",
      "Westminster",
      "Wheat Ridge",
      "Arvada",
      "Denver",
      "Englewood",
      "Littleton",
      "Centennial",
      "Lone Tree",
      "Castle Pines",
      "Castle Rock",
    ],
    brandKicker: "Tree Stump Grinding Service",
    metaTitle: "Tree Stump Grinding / Removal Service | Fast, Clean, Affordable",
    metaDescription:
      "Professional tree stump grinding service for homes and businesses. Fast scheduling, clean finish, and fair pricing. Get a free quote today.",
    ogTitle: "Tree Stump Grinding / Removal Service | Fast, Clean, Affordable",
    ogDescription:
      "Remove stumps safely and quickly with professional stump grinding. Free quotes and fast scheduling.",
    schemaType: "LocalBusiness",
    schemaDescription:
      "Professional stump grinding, stump removal, and surface root grinding for residential and commercial properties.",
    areaServed: "Colorado Front Range",
    priceRange: "$$",
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1800&q=80",
    address: {
      streetAddress: "1312 17th St, Suite: 364",
      addressLocality: "Denver",
      addressRegion: "CO",
      postalCode: "80202",
      addressCountry: "US",
    },
    leadDomainName: "EasyStumpOut.com",
    leadItemCategory: "Customer.easystumpout.production",
    leadItemType: "easystumpout.quote_request",
    seasonalNote:
      "Wet soil and rocky areas can affect time and cleanup. We’ll confirm expectations before we start.",
  },
  cheyenne: {
    key: "cheyenne",
    webSiteVersion: "v02c",
    websiteName: "CheyenneStumpRemoval.com",
    logoPart1:"Cheyenne",
    logoPart2:"Stump",
    logoPart3:"Removal.com",

    websiteUrl: "https://CheyenneStumpRemoval.com",
    businessName: "CheyenneStumpRemoval",
    phoneNumber: "3073177323",
    phoneNumberFormatted: "(307) 317-7323",
    phoneHref: "tel:+13073177323",
    email: "quotes@CheyenneStumpRemoval.com",
    hours: "Mon–Sat, 8am–6pm",
    serviceAreas: [
      "Cheyenne",
      "Laramie",
      "Pine Bluffs",
      "Burns",
      "Carpenter",
      "Granite Canyon",
      "Chugwater",
      "Torrington",
      "Wheatland",
      "Ault",
      "Wellington",
      "Fort Collins",
      "Timnath",
      "Loveland",
      "Greeley",
    ],
    brandKicker: "Tree Stump Grinding Service",
    metaTitle: "Tree Stump Grinding / Removal Service | Fast, Clean, Affordable",
    metaDescription:
      "Professional tree stump grinding service for homes and businesses. Fast scheduling, clean finish, and fair pricing. Get a free quote today.",
    ogTitle: "Tree Stump Grinding / Removal Service | Fast, Clean, Affordable",
    ogDescription:
      "Remove stumps safely and quickly with professional stump grinding. Free quotes and fast scheduling.",
    schemaType: "LocalBusiness",
    schemaDescription:
      "Professional stump grinding, stump removal, and surface root grinding for residential and commercial properties.",
    areaServed: "Colorado Front Range",
    priceRange: "$$",
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1800&q=80",
    address: {
      streetAddress: "123 Main St",
      addressLocality: "Cheyenne",
      addressRegion: "WY",
      postalCode: "82002",
      addressCountry: "US",
    },
    leadDomainName: "CheyenneStumpRemoval.com",
    leadItemCategory: "Customer.CheyenneStumpRemoval.production",
    leadItemType: "CheyenneStumpRemoval.quote_request",
    seasonalNote:
      "Wet soil and rocky areas can affect time and cleanup. We’ll confirm expectations before we start.",
  },
  denver: {
    key: "denver",
    webSiteVersion: "v02c",
    websiteName: "DenverStumpRemoval.com",

    logoPart1:"Denver",
    logoPart2:"Stump",
    logoPart3:"Removal.com",

    websiteUrl: "https://DenverStumpRemoval.com",
    businessName: "DenverStumpRemoval",
    phoneNumber: "7205383528",
    phoneNumberFormatted: "(720) 538-3528",
    phoneHref: "tel:+17205383528",
    email: "quotes@DenverStumpRemoval.com",
    hours: "Mon–Sat, 8am–6pm",
    serviceAreas: [
      "Fort Collins",
      "Johnstown",
      "Berthoud",
      "Loveland",
      "Longmont",
      "Boulder",
      "Superior",
      "Louisville",
      "Lafayette",
      "Erie",
      "Northglenn",
      "Broomfield",
      "Thornton",
      "Westminster",
      "Wheat Ridge",
      "Arvada",
      "Denver",
      "Englewood",
      "Littleton",
      "Centennial",
      "Lone Tree",
      "Castle Pines",
      "Castle Rock",
    ],
    brandKicker: "Tree Stump Grinding Service",
    metaTitle: "Tree Stump Grinding / Removal Service | Fast, Clean, Affordable",
    metaDescription:
      "Professional tree stump grinding service for homes and businesses. Fast scheduling, clean finish, and fair pricing. Get a free quote today.",
    ogTitle: "Tree Stump Grinding / Removal Service | Fast, Clean, Affordable",
    ogDescription:
      "Remove stumps safely and quickly with professional stump grinding. Free quotes and fast scheduling.",
    schemaType: "LocalBusiness",
    schemaDescription:
      "Professional stump grinding, stump removal, and surface root grinding for residential and commercial properties.",
    areaServed: "Colorado Front Range",
    priceRange: "$$",
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1800&q=80",
    address: {
      streetAddress: "1312 17th St, Suite: 364",
      addressLocality: "Denver",
      addressRegion: "CO",
      postalCode: "80202",
      addressCountry: "US",
    },
    leadDomainName: "DenverStumpRemoval.com",
    leadItemCategory: "Customer.DenverStumpRemoval.production",
    leadItemType: "DenverStumpRemoval.quote_request",
    seasonalNote:
      "Wet soil and rocky areas can affect time and cleanup. We’ll confirm expectations before we start.",
  },
};


// inlinePageStyles.ts
// Description: Inline page styles string
// Version: v01


export const DEFAULT_EASY_STUMP_OUT_LOCATION_KEY = "coloradoFrontRange";

export const DEFAULT_EASY_STUMP_OUT_LOCATION =
  EASY_STUMP_OUT_LOCATION_DATA[DEFAULT_EASY_STUMP_OUT_LOCATION_KEY];